import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PhoneDetails } from '../interfaces/phone-details';

@Injectable({
  providedIn: 'root'
})
export class PhoneValidService {

  private _onPhoneValid = new BehaviorSubject<PhoneDetails>({
    phoneNumber: '',
    countryCode: '',
    dialCode: '',
  });

  constructor() { }

  // Expose the observable for subscribing
  get phoneDetails$() {
    return this._onPhoneValid.asObservable();
  }

  // Method to update the phone details
  updatePhoneDetails(phoneDetails: PhoneDetails) {
    this._onPhoneValid.next(phoneDetails);
  }
}
